import useGoogleAnalytics from './use-google-analytics';

export { useGoogleAnalytics };

export default useGoogleAnalytics;
